document.addEventListener('DOMContentLoaded', () => {
  const members = document.querySelectorAll('.team__member')
  let teamSwiper = null
  let originalPositions = new Map()

  members.forEach((member) => {
    const style = member.getAttribute('style')
    if (style) {
      originalPositions.set(member, style)
    }
  })

  members.forEach((member) => {
    member.addEventListener('mouseenter', () => {
      if (window.innerWidth <= 1279.7) return

      const rect = member.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2

      members.forEach((el) => {
        el.classList.remove('active')

        if (el === member) {
          el.classList.add('active')
          el.style.transform = 'scale(1.1)'
          el.style.zIndex = 10
          return
        }

        const elRect = el.getBoundingClientRect()
        const elCenterX = elRect.left + elRect.width / 2
        const elCenterY = elRect.top + elRect.height / 2

        const dx = elCenterX - centerX
        const dy = elCenterY - centerY

        let offsetX = 0
        let offsetY = 0
        const baseOffset = 180 + Math.random() * 50

        if (Math.abs(dx) > Math.abs(dy)) {
          offsetX = dx > 0 ? baseOffset : -baseOffset
          offsetY = (Math.random() - 0.5) * 20
        } else {
          offsetY = dy > 0 ? baseOffset : -baseOffset
          offsetX = (Math.random() - 0.5) * 20
        }

        el.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(0.95)`
        el.style.zIndex = 1
      })
    })

    member.addEventListener('mouseleave', () => {
      if (window.innerWidth <= 1024) return

      members.forEach((el) => {
        el.classList.remove('active')
        el.style.transform = ''
        el.style.zIndex = ''
      })
    })
  })

  function initSwiper() {
    if (window.innerWidth <= 1024 && !teamSwiper) {
      // Сбрасываем стили карточек для корректной работы слайдера
      members.forEach((member) => {
        member.style.position = 'static'
        member.style.transform = 'none'
        member.style.left = ''
        member.style.top = ''
        member.style.width = ''
        member.style.height = ''
        member.style.zIndex = ''
        member.classList.add('swiper-slide')
      })

      // Убеждаемся, что контейнер имеет правильную структуру для Swiper
      const mapContainer = document.querySelector('.our_people__team-wrapper_map')
      if (mapContainer && !mapContainer.classList.contains('swiper')) {
        mapContainer.classList.add('swiper')

        // Создаем обертку Swiper если её нет
        if (!mapContainer.querySelector('.swiper-wrapper')) {
          const wrapper = document.createElement('div')
          wrapper.className = 'swiper-wrapper'

          // Перемещаем все карточки в обертку
          while (mapContainer.firstChild) {
            wrapper.appendChild(mapContainer.firstChild)
          }
          mapContainer.appendChild(wrapper)

          // Создаем пагинацию если её нет
          if (!mapContainer.querySelector('.swiper-pagination')) {
            const pagination = document.createElement('div')
            pagination.className = 'swiper-pagination'
            mapContainer.appendChild(pagination)
          }
        }
      }

      teamSwiper = new Swiper('.our_people__team-wrapper_map', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: false,
        loop: false,
        autoplay: {
          // автопереключение
          delay: 3000, // Задержка в миллисекундах (3 секунды)
          disableOnInteraction: true,
          el: '.swiper-pagination',
          clickable: true,
        },
        breakpoints: {
          375: {
            slidesPerView: 1,
            centeredSlides: true,
            spaceBetween: 8,
          },
          768: {
            slidesPerView: 2,
            centeredSlides: false,
            spaceBetween: 16,
          },
        },
        on: {
          init: function () {
            this.update()
          },
        },
      })

      setTimeout(() => {
        if (teamSwiper) {
          teamSwiper.update()
          teamSwiper.updateSlides()
        }
      }, 100)
    }
  }

  function destroySwiper() {
    if (window.innerWidth > 1024 && teamSwiper) {
      teamSwiper.destroy(true, true)
      teamSwiper = null
    }

    // Восстанавливаем оригинальные позиции карточек
    members.forEach((member) => {
      const originalStyle = originalPositions.get(member)
      if (originalStyle) {
        member.setAttribute('style', originalStyle)
      } else {
        // Если оригинальные стили не сохранились, устанавливаем базовые
        member.style.position = 'absolute'
        member.style.transform = ''
        member.style.zIndex = ''
      }

      // Убираем классы, добавленные Swiper
      member.classList.remove('swiper-slide', 'swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev')
    })

    // Также восстанавливаем структуру контейнера
    const mapContainer = document.querySelector('.our_people__team-wrapper_map')
    if (mapContainer) {
      mapContainer.classList.remove('swiper')
      const wrapper = mapContainer.querySelector('.swiper-wrapper')
      if (wrapper) {
        wrapper.classList.remove('swiper-wrapper')
        // Перемещаем карточки обратно в основной контейнер
        while (wrapper.firstChild) {
          mapContainer.appendChild(wrapper.firstChild)
        }
        wrapper.remove()
      }
    }
  }

  if (window.innerWidth <= 1279.7) {
    initSwiper()
  }

  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1279.7) {
      initSwiper()
    } else {
      destroySwiper()
    }
  })
})
